module.exports = __webpack_public_path__ + "static/media/oecd_dac_codes.e455ec5a.svg";